// {value: 111, children: [{value: 222}]}
// export function compareTreeData(trees, value) {
export function compareTreeData(trees, value) {
  const innerValue = value.slice();
  const root = { value: 'ROOT_VALUE', children: trees };
  const res = [];

  _compareTreeData(root);

  return res.concat(innerValue).map((item) => safeValue(item).slice(1));

  function _compareTreeData(tree, parenvValuePath = []) {
    // 如果没有可合并的内容直接返回，不要再迭代了
    if (innerValue.length === 0) return;

    // 如果存在就直接push进去
    if (innerValue.includes(tree.value)) return tree.value;

    if (!tree.children) return;

    const childValues = [];
    let stmp;

    for (var i = 0; i < tree.children.length; i++) {
      stmp = _compareTreeData(tree.children[i], [...parenvValuePath, tree.value]);
      if (stmp != undefined) childValues.push(stmp);
    }

    // 子元素的值一个都没有在values里面
    if (childValues.length === 0) return;

    // 子元素全在values里
    if (childValues.length === tree.children.length) {
      remove(innerValue, childValues);
      // 把自己加到value里，用于后续的合并
      innerValue.push(tree.value);
      return tree.value;
    }

    // 部分子元素在values里面
    remove(innerValue, childValues);

    // 有部分在有部分不在
    res.push(...childValues.map((item) => [...parenvValuePath, tree.value, item]));
  }

  // 从origin中把cache的内容值删掉
  function remove(origin, cache) {
    const _cache = cache.reduce((total, cur) => {
      total[cur] = true;
      return total;
    }, {});

    for (var i = 0; i < origin.length; i++) {
      if (_cache[origin[i]]) {
        origin.splice(i, 1);
        i--;
      }
    }

    return origin;
  }

  function safeValue(val) {
    if (Array.isArray(val)) return val;
    return [root.value, val];
  }
}

function test() {
  const data = [
    {
      value: 1,
      children: [
        { value: 2 },
        {
          value: 3,
          children: [{ value: 10 }, { value: 11 }, { value: 1000, children: [{ value: 1001 }, { value: 1002 }] }],
        },
      ],
    },
    {
      value: 100,
      children: [{ value: 200 }, { value: 300 }],
    },
  ];

  // console.log(compareTreeData(data, [2]));
  // console.log(compareTreeData(data, [1]));
  // // 不存在
  // console.log(compareTreeData(data, [-1])); // [ [ -1 ] ]
  // console.log(compareTreeData(data, [1])); // [ [ 1 ] ]
  // console.log(compareTreeData(data, [1002])); // [ [ 1 ] ]
  // console.log(compareTreeData(data, [3])); // [ [ 1, 3 ] ]
  // console.log(compareTreeData(data, [1000])); // [ [ 1, 3, 1000 ] ]
  // console.log(compareTreeData(data, [2, 3])); // [ [ 1 ] ]
  // console.log(compareTreeData(data, [2])); // [ [ 1, 2 ] ]
  // console.log(compareTreeData(data, [100])); // [ [ 100 ] ]
  // console.log(compareTreeData(data, [200])); // [ [ 100, 200 ] ]
  // console.log(compareTreeData(data, [200, 300])); // [ [ 100 ] ]
  // console.log(compareTreeData(data, [1001, 1002])); // [ [ 1, 3, 1000 ] ]
  // console.log(compareTreeData(data, [1000, 11])); // [ [ 1, 3, 11 ], [1, 3, 1000] ]
  // console.log(compareTreeData(data, [300, 1002])); // [ [ 100, 300 ], [1, 3, 1000, 1002] ]
}
